import React, { useState } from 'react';
import Select from 'react-select';
import { FaPlus, FaEye } from 'react-icons/fa';
import { toast } from 'react-toastify';
import { Link } from 'react-router-dom';
import { isEmail } from 'validator';
import { useSelector } from 'react-redux';
import dayjs from 'dayjs';

import { Container, Filtros } from '../../styles/GlobalStyles';
import {
  Adicionar, BotaoDisciplina, Concursos, SelectNome,
  NomeEmpresa, Botoes,
} from './styled';
import axios from '../../services/axios';
import Loading from '../../components/Loading';

export default function Principal() {
  const nivel = useSelector((state) => state.auth.user.nivel);

  const [nomeEmpresa, setNomeEmpresa] = useState('');
  const [dataInicioInscriscoes, setDataInicioInscriscoes] = useState('');
  const [dataFimInscriscoes, setDataFimInscriscoes] = useState('');
  const [horaInicioInscriscoes, setHoraInicioInscriscoes] = useState('');
  const [horaFimInscriscoes, setHoraFimInscriscoes] = useState('');
  const [dataProva, setDataProva] = useState('');
  const [horaInicioProva, setHoraInicioProva] = useState('');
  const [horaFimProva, setHoraFimProva] = useState('');
  const [tempoRealizacaoProva, setTempoRealizacaoProva] = useState('');
  const [dataEnvioRecurso, setDataEnvioRecurso] = useState('');
  const [dataLimiteEnvioRecurso, setDataLimiteEnvioRecurso] = useState('');
  const [horaInicioRecurso, setHoraInicioRecurso] = useState('');
  const [horaFimRecurso, setHoraFimRecurso] = useState('');
  const [emailEnvioRecurso, setEmailEnvioRecurso] = useState('');
  const [dataPublicacaoResultadoProvisorio, setDataPublicacaoResultadoProvisorio] = useState('');
  const [dataPublicacaoResultadoOficial, setDataPublicacaoResultadoOficial] = useState('');
  const [dataLimiteVisualizacao, setDataLimiteVisualizacao] = useState('');
  const [addition, setAddition] = useState(true);
  const [result, setResult] = useState([]);
  const [lists, setLists] = useState([]);
  const [id, setId] = useState('');
  const [isLoading, setIsLoading] = useState(false);
  const [botao, setBotao] = useState(false);
  const [provasExiste, setprovaExiste] = useState(false);

  const getDatas = async (value) => {
    // Colocar um loading no select, durante o input
    try {
      const response = await axios(`/concursos/?termo=${value}`);
      let results = response.data;

      const aberto = document.getElementById('abertos');

      const finalizados = document.getElementById('finalizar');

      const proximasProva = document.getElementById('prova-proximas');

      const provasFinalizadas = document.getElementById('anteriores-provas');

      if (aberto.checked) {
        results = results.filter((res) => dayjs().isBefore(res.data_fim_inscricoes, 'day') === true);
      }

      if (finalizados.checked) {
        results = results.filter((res) => dayjs().isAfter(res.data_fim_inscricoes, 'day') === true);
      }

      if (proximasProva.checked) {
        results = results.filter((res) => dayjs().isBefore(res.data_prova, 'day') === true);
      }

      if (provasFinalizadas.checked) {
        results = results.filter((res) => dayjs().isAfter(res.data_prova, 'day') === true);
      }

      const options = [];

      // eslint-disable-next-line no-plusplus
      for (let i = 0; i < results.length; i++) {
        options.push({
          value: `${results[i].id}`,
          label: `${results[i].nome_empresa}`,
        });
      }

      setResult(options);
    } catch (error) {
      toast.error(error.message);
    }
  };

  const handleChange = (value) => {
    if (value.length === 0) {
      setResult([]);
    } else {
      getDatas(value);
    }
  };

  const handleProvas = (provasCompletas) => {
    setprovaExiste(false);
    provasCompletas.map(async (prova) => {
      try {
        const data = await axios(`/questoes/${prova.id}`);

        if (data.data.length === Number(prova.quantidade_questoes)) {
          setprovaExiste(true);
        }
      } catch {
        toast.error('Erro ao visualizar prova.');
      }
    });
  };

  const onChange = async (data) => {
    if (data.value) {
      const disciplinas = await axios('/disciplina/');

      try {
        setIsLoading(true);
        const dados = await axios(`/concursos/${data.value}`);

        const results = dados.data;

        setNomeEmpresa(results.nome_empresa);
        setDataInicioInscriscoes(results.data_inicio_inscricoes);
        setDataFimInscriscoes(results.data_fim_inscricoes);
        setHoraInicioInscriscoes(results.hora_inicio_inscricoes);
        setHoraFimInscriscoes(results.hora_fim_inscricoes);
        setDataProva(results.data_prova);
        setHoraInicioProva(results.hora_inicio_prova);
        setHoraFimProva(results.hora_fim_prova);
        setTempoRealizacaoProva(results.tempo_realizacao_prova);
        setDataEnvioRecurso(results.data_envio_recurso);
        setDataLimiteEnvioRecurso(results.data_limite_envio_recurso);
        setHoraInicioRecurso(results.hora_inicio_recurso);
        setHoraFimRecurso(results.hora_fim_recurso);
        setEmailEnvioRecurso(results.email_envio_recurso);
        setDataPublicacaoResultadoProvisorio(results.data_publicacao_resultado_provisorio);
        setDataPublicacaoResultadoOficial(results.data_publicacao_resultado_oficial);
        setDataLimiteVisualizacao(results.data_limite_visualizacao);

        setBotao(true);

        setId(data.value);
        setAddition(false);

        handleProvas(disciplinas.data.filter((d) => d.id_identificacao_empresa
          === Number(data.value)));

        setIsLoading(false);
      } catch (err) {
        setIsLoading(false);
        toast.error('Não foi possível carregar os dados.');
      }
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    let formErros = false;

    if (nomeEmpresa.length < 3 || nomeEmpresa.length > 255) {
      toast.error('Nome Empresa precisa ter entre 3 e 255 caracteres');
      formErros = true;
    }

    const regexD = /^[0-9]{4}-[0-9]{2}-[0-9]{2}$/;

    if (!regexD.test(dataInicioInscriscoes)) {
      toast.error('Data de início das inscrisções inválida!');
      formErros = true;
    }

    if (!regexD.test(dataFimInscriscoes)) {
      toast.error('Data de fim das inscrisções inválida!');
      formErros = true;
    }

    const regexH = /^[0-9]{2}:[0-9]{2}$/;

    const regexHBD = /^[0-9]{2}:[0-9]{2}:[0-9]{2}$/;

    if ((!id && !regexH.test(horaInicioInscriscoes))
      || ((id && !regexHBD.test(horaInicioInscriscoes)))) {
      toast.error('Hora de início das inscrisções inválida!');
      formErros = true;
    }

    if ((!id && !regexH.test(horaFimInscriscoes))
      || (id && !regexHBD.test(horaFimInscriscoes))) {
      toast.error('Hora de fim das inscrisções inválida!');
      formErros = true;
    }

    if (!regexD.test(dataProva)) {
      toast.error('Data de prova inválida!');
      formErros = true;
    }

    if ((!id && !regexH.test(horaInicioProva)) || (id && !regexHBD.test(horaInicioProva))) {
      toast.error('Hora de início da prova inválida!');
      formErros = true;
    }

    if ((!id && !regexH.test(horaFimProva)) || (id && !regexHBD.test(horaInicioInscriscoes))) {
      toast.error('Hora de fim da prova inválida!');
      formErros = true;
    }

    if ((!id && !regexH.test(tempoRealizacaoProva))
      || (id && !regexHBD.test(horaInicioInscriscoes))) {
      toast.error('Tempo de realização da prova inválido!');
      formErros = true;
    }

    if (!regexD.test(dataEnvioRecurso)) {
      toast.error('Data de envio de recurso inválida!');
      formErros = true;
    }

    if (!regexD.test(dataLimiteEnvioRecurso)) {
      toast.error('Data limite de recurso inválida!');
      formErros = true;
    }

    if ((!id && !regexH.test(horaInicioRecurso)) || (id && !regexHBD.test(horaInicioRecurso))) {
      toast.error('Hora de início do recurso inválida!');
      formErros = true;
    }

    if ((!id && !regexH.test(horaFimRecurso)) || (id && !regexHBD.test(horaFimRecurso))) {
      toast.error('Hora de início do recurso inválida!');
      formErros = true;
    }

    if (!isEmail(emailEnvioRecurso)) {
      toast.error('Email inválido!');
      formErros = true;
    }

    if (!regexD.test(dataPublicacaoResultadoProvisorio)) {
      toast.error('Data limite de recurso inválida!');
      formErros = true;
    }

    if (!regexD.test(dataPublicacaoResultadoOficial)) {
      toast.error('Data limite de recurso inválida!');
      formErros = true;
    }

    if (!regexD.test(dataLimiteVisualizacao)) {
      toast.error('Data limite de recurso inválida!');
      formErros = true;
    }

    if (formErros) return;

    if (nivel === '1') {
      toast.error('Você não tem permissão para prosseguir com essa ação.');
      return;
    }

    setBotao(true);

    setIsLoading(true);

    try {
      if (!id) {
        axios.post('/concursos/', {
          nome_empresa: nomeEmpresa,
          data_inicio_inscricoes: dataInicioInscriscoes,
          hora_inicio_inscricoes: horaInicioInscriscoes,
          data_fim_inscricoes: dataFimInscriscoes,
          hora_fim_inscricoes: horaFimInscriscoes,
          data_prova: dataProva,
          hora_inicio_prova: horaInicioProva,
          tempo_realizacao_prova: tempoRealizacaoProva,
          hora_fim_prova: horaFimProva,
          data_envio_recurso: dataEnvioRecurso,
          hora_inicio_recurso: horaInicioRecurso,
          data_limite_envio_recurso: dataLimiteEnvioRecurso,
          hora_fim_recurso: horaFimRecurso,
          email_envio_recurso: emailEnvioRecurso,
          data_publicacao_resultado_provisorio: dataPublicacaoResultadoProvisorio,
          data_publicacao_resultado_oficial: dataPublicacaoResultadoOficial,
          data_limite_visualizacao: dataLimiteVisualizacao,
        }).then((response) => {
          axios(`/concursos/${response.data.id}`)
            .then((results) => {
              setNomeEmpresa(results.data.nome_empresa);
              setDataInicioInscriscoes(results.data.data_inicio_inscricoes);
              setDataFimInscriscoes(results.data.data_fim_inscricoes);
              setHoraInicioInscriscoes(results.data.hora_inicio_inscricoes);
              setHoraFimInscriscoes(results.data.hora_fim_inscricoes);
              setDataProva(results.data.data_prova);
              setHoraInicioProva(results.data.hora_inicio_prova);
              setHoraFimProva(results.data.hora_fim_prova);
              setTempoRealizacaoProva(results.data.tempo_realizacao_prova);
              setDataEnvioRecurso(results.data.data_envio_recurso);
              setDataLimiteEnvioRecurso(results.data.data_limite_envio_recurso);
              setHoraInicioRecurso(results.data.hora_inicio_recurso);
              setHoraFimRecurso(results.data.hora_fim_recurso);
              setEmailEnvioRecurso(results.data.email_envio_recurso);
              setDataPublicacaoResultadoProvisorio(results.data
                .data_publicacao_resultado_provisorio);
              setDataPublicacaoResultadoOficial(results.data.data_publicacao_resultado_oficial);
              setDataLimiteVisualizacao(results.data.data_limite_visualizacao);

              setId(response.data.id);

              setAddition(false);

              toast.success('Concurso cadastrado com sucesso!');
            }).catch(() => toast.error('Erro ao cadastrar concurso'));
        });
      } else {
        await axios.put(`/concursos/${id}`, {
          nome_empresa: nomeEmpresa,
          data_inicio_inscricoes: dataInicioInscriscoes,
          hora_inicio_inscricoes: horaInicioInscriscoes,
          data_fim_inscricoes: dataFimInscriscoes,
          hora_fim_inscricoes: horaFimInscriscoes,
          data_prova: dataProva,
          hora_inicio_prova: horaInicioProva,
          tempo_realizacao_prova: tempoRealizacaoProva,
          hora_fim_prova: horaFimProva,
          data_envio_recurso: dataEnvioRecurso,
          hora_inicio_recurso: horaInicioRecurso,
          data_limite_envio_recurso: dataLimiteEnvioRecurso,
          hora_fim_recurso: horaFimRecurso,
          email_envio_recurso: emailEnvioRecurso,
          data_publicacao_resultado_provisorio: dataPublicacaoResultadoProvisorio,
          data_publicacao_resultado_oficial: dataPublicacaoResultadoOficial,
          data_limite_visualizacao: dataLimiteVisualizacao,
        });
        toast.success('Concurso editado com sucesso!');
      }

      setIsLoading(false);
    } catch (err) {
      setIsLoading(false);
      toast.error('Erro ao fazer cadastro do concurso!');
    }
  };

  const handleClick = () => {
    setAddition(true);
    setId('');
    setNomeEmpresa('');
    setDataInicioInscriscoes('');
    setDataFimInscriscoes('');
    setHoraInicioInscriscoes('');
    setHoraFimInscriscoes('');
    setDataProva('');
    setHoraInicioProva('');
    setHoraFimProva('');
    setTempoRealizacaoProva('');
    setDataEnvioRecurso('');
    setDataLimiteEnvioRecurso('');
    setHoraInicioRecurso('');
    setHoraFimRecurso('');
    setEmailEnvioRecurso('');
    setDataPublicacaoResultadoProvisorio('');
    setDataPublicacaoResultadoOficial('');
    setDataLimiteVisualizacao('');
    setBotao(false);
  };

  const getDatasNome = async (value) => {
    try {
      setIsLoading(true);
      const response = await axios(`/empresa/?termo=${value}`);
      const results = response.data;

      const options = [];

      // eslint-disable-next-line no-plusplus
      for (let i = 0; i < results.length; i++) {
        options.push({
          value: `${results[i].razaosocial}`,
          label: `${results[i].razaosocial}`,
        });
      }

      setLists(options);
      setIsLoading(false);
    } catch (e) {
      setIsLoading(false);
      toast.error(e.message);
    }
  };

  const handleChangeNome = (value) => {
    if (value.length === 0) {
      setLists([]);
    } else {
      getDatasNome(value);
    }
  };

  const onChangeNome = (data) => {
    setNomeEmpresa(data.value);
  };

  const handleVerify = () => {
    if (!provasExiste) {
      toast.error('Não existe nenhuma discilina completa para este concurso.');
    }
  };

  return (
    <Container>

      <Select
        options={result}
        onInputChange={handleChange}
        onChange={onChange}
        placeholder="Pesquisar Concurso..."
      />

      <Filtros>
        <label htmlFor="abertos">
          <input id="abertos" type="checkbox" />
          Concursos em aberto
        </label>

        <label htmlFor="finalizar">
          <input id="finalizar" type="checkbox" />
          Concursos finalizados
        </label>

        <label htmlFor="prova-proximas">
          <input id="prova-proximas" type="checkbox" />
          Próximas provas
        </label>

        <label htmlFor="anteriores-provas">
          <input id="anteriores-provas" type="checkbox" />
          Provas Realizadas
        </label>
      </Filtros>

      <Botoes>
        {(nivel !== '1') && (
        <Adicionar onClick={handleClick}>
          <FaPlus size={16} />
          <p>Adicionar Concurso</p>
        </Adicionar>
        )}

        {id && (
        <Link onClick={handleVerify} to={provasExiste ? `/provascompletas/${id}` : '/'}>
          <FaEye size={16} />
          <p>Visualizar Prova Completa</p>
        </Link>
        )}
      </Botoes>

      <Concursos>

        <Loading isLoading={isLoading} />

        <form onSubmit={(e) => (handleSubmit(e))}>
          <SelectNome>
            <Select
              options={lists}
              onInputChange={handleChangeNome}
              onChange={(e) => onChangeNome(e)}
              placeholder="Pesquisar Empresa..."
            />
          </SelectNome>
          {nomeEmpresa && (
            <NomeEmpresa>
              <span>Nome da Empresa</span>
              <p>{nomeEmpresa}</p>
            </NomeEmpresa>
          )}
          <div id="left">
            <label htmlFor="inicio-inscricoes">
              Data de início das inscrições
              <input
                id="inicio-inscricoes"
                type="date"
                value={dataInicioInscriscoes}
                onChange={(e) => setDataInicioInscriscoes(e.target.value)}
              />
            </label>
            <label htmlFor="fim-inscricoes">
              Data de fim das inscrições
              <input
                id="fim-inscricoes"
                type="date"
                value={dataFimInscriscoes}
                onChange={(e) => setDataFimInscriscoes(e.target.value)}
              />
            </label>
            <label htmlFor="hora-inicio-inscricoes">
              Hora de início das inscrições
              <input
                id="hora-inicio-inscricoes"
                type="time"
                value={horaInicioInscriscoes}
                onChange={(e) => setHoraInicioInscriscoes(e.target.value)}
              />
            </label>
            <label htmlFor="hora-fim-inscricoes">
              Hora de fim das inscrições
              <input
                id="hora-fim-inscricoes"
                type="time"
                value={horaFimInscriscoes}
                onChange={(e) => setHoraFimInscriscoes(e.target.value)}
              />
            </label>
            <label htmlFor="data-prova">
              Data da prova
              <input
                id="data-prova"
                type="date"
                value={dataProva}
                onChange={(e) => setDataProva(e.target.value)}
              />
            </label>
            <label htmlFor="hora-inicio-prova">
              Hora de início da prova
              <input
                id="hora-inicio-prova"
                type="time"
                value={horaInicioProva}
                onChange={(e) => setHoraInicioProva(e.target.value)}
              />
            </label>
            <label htmlFor="hora-fim-prova">
              Hora do fim da prova
              <input
                id="hora-fim-prova"
                type="time"
                value={horaFimProva}
                onChange={(e) => setHoraFimProva(e.target.value)}
              />
            </label>
            <label htmlFor="tempo-realizacao">
              Tempo de realização de prova
              <input
                id="tempo-realizacao"
                type="time"
                value={tempoRealizacaoProva}
                onChange={(e) => setTempoRealizacaoProva(e.target.value)}
              />
            </label>
          </div>
          <div id="right">
            <label htmlFor="data-envio-recurso">
              Data de envio de recurso
              <input
                id="data-envio-recurso"
                type="date"
                value={dataEnvioRecurso}
                onChange={(e) => setDataEnvioRecurso(e.target.value)}
              />
            </label>
            <label htmlFor="data-limite-recurso">
              Data de limite do recurso
              <input
                id="data-limite-recurso"
                type="date"
                value={dataLimiteEnvioRecurso}
                onChange={(e) => setDataLimiteEnvioRecurso(e.target.value)}
              />
            </label>
            <label htmlFor="hora-inicio-recurso">
              Hora de início do recurso
              <input
                id="hora-inicio-recurso"
                type="time"
                value={horaInicioRecurso}
                onChange={(e) => setHoraInicioRecurso(e.target.value)}
              />
            </label>
            <label htmlFor="hora-fim-recurso">
              Hora final do recurso
              <input
                id="hora-fim-recurso"
                type="time"
                value={horaFimRecurso}
                onChange={(e) => setHoraFimRecurso(e.target.value)}
              />
            </label>
            <label htmlFor="email-recurso">
              Email para enviar recurso
              <input
                id="email-recurso"
                type="email"
                value={emailEnvioRecurso}
                onChange={(e) => setEmailEnvioRecurso(e.target.value)}
              />
            </label>
            <label htmlFor="data-resultado-provisorio">
              Data de resultado provisório
              <input
                id="data-resultado-provisorio"
                type="date"
                value={dataPublicacaoResultadoProvisorio}
                onChange={(e) => setDataPublicacaoResultadoProvisorio(e.target.value)}
              />
            </label>
            <label htmlFor="data-resultado-oficial">
              Data da publicação do resultado oficial
              <input
                id="data-resultado-oficial"
                type="date"
                value={dataPublicacaoResultadoOficial}
                onChange={(e) => setDataPublicacaoResultadoOficial(e.target.value)}
              />
            </label>

            <label htmlFor="data-limite-visualizacao">
              Data limite de visualização do resultado
              <input
                id="data-limite-visualizacao"
                type="date"
                value={dataLimiteVisualizacao}
                onChange={(e) => setDataLimiteVisualizacao(e.target.value)}
              />
            </label>
          </div>
          {(nivel !== '1' && (
            <div id="submit-concurso">
              <button type="submit">{addition ? 'Enviar' : 'Editar Concurso'}</button>
            </div>
          )
        )}
        </form>
      </Concursos>

      {(botao && nivel !== '1') && (
        <BotaoDisciplina>
          <Link to={`/disciplina/${id}`}>
            <button type="button">Adicionar Disciplina</button>
          </Link>
        </BotaoDisciplina>
      )}

    </Container>
  );
}
